import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperCustomRangeSlider: {
      width: "300px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      width: "100%",
    },
    containerMinMax: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems: "center",
    },
    containerMin: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
    },
    dashMark: {
      marginTop: "30px",
    },
    slider: {
      "& .MuiSlider-rail": {
        width: "100%",
        height: "8px",
        display: "block",
        opacity: 0.38,
        position: "absolute",
        borderRadius: "12px",
        backgroundColor: theme.palette.background.gray_200,
      },
      "& .MuiSlider-track": {
        height: "8px",
        borderRadius: "12px",
      },
      "& .MuiSlider-thumb": {
        marginTop: "-8px",
        width: "26px",
        height: "26px",
        zIndex: 0,
        "&::after": {
          content: '""',
          position: "absolute",
          top: "3px",
          left: "2.99px",
          width: "20px",
          height: "20px",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "50%",
          zIndex: -1,
        },
      },
    },
    MaxMineTitle: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
  };
});
